import Services from './services.service'
import axios from '@/plugins/axios'
import { disableInterceptor, disableInterceptorOk } from "@/utils/HeaderNoInterceptors";

class UserService extends Services {
  
  validarEmail(email: string): Promise<string> {
    const login = axios.post<{ mensaje: string }>('front/check-email', { email }, disableInterceptor)
    return login.then(res => {
      return res.data.mensaje
    })
  }

  validarDni(dni: number): Promise<boolean> {
    const url = 'https://central.eventhub.la/api/usuarios/check-dni'
    const token = 'b83f9e8a2c9c4d17a4e8c345b99e8b4f2d8a9ef77d9c1b3e5d2c4a6e9f8b7c1'
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    return axios.post<{ exists: boolean }>(url, { dni: dni.toString() }, { headers })
      .then(res => res.data.exists)
  }

  validarVin(vin: string): Promise<boolean> {
  const url = 'https://central.eventhub.la/api/fidelizados/check-vin'
  const token = 'b83f9e8a2c9c4d17a4e8c345b99e8b4f2d8a9ef77d9c1b3e5d2c4a6e9f8b7c1'
  return axios.post<{ exists: boolean }>(
    url,
    { vin },
    {
      ...disableInterceptor,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  ).then(res => res.data.exists)
}


  registrar(form: object): Promise<string> {
    const login = axios.post<{ mensaje: string }>('front/registrar', form, disableInterceptorOk)
    return login.then(res => {
      return res.data.mensaje
    })
  }

  registrarFidelizacion(form: object): Promise<string> {
    const login = axios.post<{ mensaje: string }>('front/registrar-fidelizacion', form, disableInterceptorOk)
    return login.then(res => {
      return res.data.mensaje
    })
  }

  completarRegristro(form: object): Promise<string> {
    const login = axios.post<{ mensaje: string }>('front/activar', form, disableInterceptorOk)
    return login.then(res => {
      return res.data.mensaje
    })
  }

  recuperar(form: object): Promise<string> {
    const login = axios.post<{ mensaje: string }>('front/recuperar', form, disableInterceptorOk)
    return login.then(res => {
      return res.data.mensaje
    })
  }

  restablecer(form: object): Promise<string> {
    const login = axios.post<{ mensaje: string }>('front/reestablecer', form, disableInterceptorOk)
    return login.then(res => {
      return res.data.mensaje
    })
  }

  vehiculosAsociados(): Promise<any[]> {
    const vehiculos = axios.post<any[]>('front/mis-vehiculos', {}, disableInterceptorOk)
    return vehiculos.then(res => {
      return res.data
    })
  }

  agregarVehiculo(form: object): Promise<boolean> {
    const response = axios.post<boolean>('front/mis-vehiculos/agregar', form, disableInterceptorOk)
    return response.then(res => {
      return res.data
    })
  }

  async misCuponPorActividad(id: number): Promise<{ codigo: string, store_url: string }> {
    const { data } = await axios.get<{ codigo: string, store_url: string }>(`front/mis-cupones/${id}`, disableInterceptorOk)
    return data
  }

  actualizarTelefono(telefono: string, userId: number): Promise<any> {
    const response = axios.post('front/update-phone', { usuario: userId, telefono }, disableInterceptorOk)
    return response.then(res => {
      return res.data
    })
  }
}

export const userService = new UserService()
